import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@ngneat/transloco';
import { FindModule } from '@red/pipes/find';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxMaskModule } from 'ngx-mask';
import { MatExpansionModule } from '@angular/material/expansion';

import { RedPaginationModule } from '@red/components/pagination';
import { SelectSearchModule } from '@red/components/select-search';
import { TableActionGroupModule } from '@shared/components/table-action-group';
import { PermissionModule } from '@shared/permission';
import { ToastModule } from '@shared/components/toast';
import { ConfirmDialogModule } from '@shared/components/confirm-dialog';
import { BreadcrumbModule } from '@shared/components/breadcrumb';
import { VirtualScrollControllerModule } from '@shared/components/virtual-scroll-controller';
import { LoadingBoxModule } from '@shared/components/loading-box';
import { SelectCheckAllModule } from '@shared/components/select-check-all';

import { DynamicReportGeneralFormComponent } from './dynamic-report-general-form.component';
import { DynamicReportGeneralPreviewModule } from '../dynamic-report-general-preview/dynamic-report-general-preview.module';
const angularMaterialModules = [
    MatIconModule,
    MatTableModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatButtonModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatMenuModule,
    MatChipsModule,
    MatDividerModule,
    DragDropModule,
    MatRadioModule,
    NgxMaskModule,
    MatExpansionModule
];

const redModules = [
    RedPaginationModule,
    SelectSearchModule,
    FindModule,
];

const sharedComponentModules = [
    LoadingBoxModule,
    TableActionGroupModule,
    ToastModule,
    ConfirmDialogModule,
    BreadcrumbModule,
    VirtualScrollControllerModule,
    SelectCheckAllModule,
];

@NgModule({
    declarations: [DynamicReportGeneralFormComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ...angularMaterialModules,
        ...redModules,
        ...sharedComponentModules,
        TranslocoModule,
        PermissionModule,
        DynamicReportGeneralPreviewModule
    ],
    exports: [DynamicReportGeneralFormComponent],
    //providers: [useDynamicReportLoader(ProjectDynamicReportLoaderService)]
})
export class DynamicReportGeneralFormModule { } 